import { render } from "./PassThrough.vue?vue&type=template&id=cb8111ac"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/PassThrough.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cb8111ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cb8111ac', __exports__)) {
    api.reload('cb8111ac', __exports__)
  }
  
  module.hot.accept("./PassThrough.vue?vue&type=template&id=cb8111ac", () => {
    api.rerender('cb8111ac', render)
  })

}


export default __exports__